import type { Reference } from '@sydle/sydle-one-components';
import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { ExecuteMethodResponse } from '../models/api/ExecuteMethodResponse';
import type { TicketComment } from '../models/ticket/TicketComment';

export interface ExecuteActionInput {
  ticketId: string;
  searchCode?: string;
  action: Reference;
  pendency?: Reference;
  post?: TicketComment;
  onlyIdentifyActionParams?: boolean;
}

export interface ExecuteActionOutput extends ExecuteMethodResponse {
  _package?: string;
  _class?: string;
  _method?: string;
  params?: any;
}

export async function executeAction(input: ExecuteActionInput): Promise<FetchResponse<ExecuteActionOutput>> {
  return await portalCustomAPI.fetch<ExecuteActionInput, ExecuteActionOutput>('executeAction', input);
}
